import React from 'react';
import { connect } from 'react-redux';
import { Box, Table, TableHead, TableBody, TableRow, TableCell, TableContainer, Button, TableSortLabel } from '@mui/material';
import { API_ROOT } from '../../../../baseUrls';
import Loader from '../../../organisms/loader/Loader';

class Users extends React.Component {
  state = {
    total: undefined,
    totalSort: undefined,
    totalReverse: undefined,
    monthly: undefined,
    monthlySort: undefined,
    monthlyReverse: undefined,
    date: undefined,
    forward: undefined,
    back: undefined,
    loadingMonthly: true,
  };

  componentDidMount() {
    this.startTotalRequest('bytes', true);
    this.startMonthlyRequest('bytes', true);
  }

  fetchTable(name, sort, reverse, date) {
    const params = [`sort=${encodeURIComponent(sort)}`, `reverse=${encodeURIComponent(+reverse)}`];
    if (date !== undefined) {
      params.push(`date=${encodeURIComponent(date.toString())}`);
    }
    return fetch(`${API_ROOT}/mindfiles/${this.props.user.mid}/admin/users/${name}?${params.join('&')}`, {
      method: 'GET',
      credentials: 'include',
    })
    .then(resp => resp.json())
    .catch(error => console.error(error));
  }

  startTotalRequest(sort, reverse) {
    this.fetchTable('total', sort, reverse)
    .then(total => this.setState({
      total: total.total,
      totalSort: sort,
      totalReverse: reverse,
    }));
  }

  startMonthlyRequest(sort, reverse, date) {
    this.setState({ loadingMonthly: true });
    this.fetchTable('monthly', sort, reverse, date)
    .then(monthly => this.setState({
      monthly: monthly.monthly,
      monthlySort: sort,
      monthlyReverse: reverse,
      date: monthly.date,
      forward: monthly.forward,
      back: monthly.back,
    }))
    .finally(() => this.setState({ loadingMonthly: false }));
  }

  render() {
    if (!Array.isArray(this.state.total) || !Array.isArray(this.state.monthly)) {
      return <Loader />;
    }
    return (
      <Box>
        <h2>Total Uploads</h2>
        <MindfileTable
          mindfiles={this.state.total}
          sort={this.state.totalSort}
          reverse={this.state.totalReverse}
          onChangeSort={this.startTotalRequest.bind(this)}
          sortDisabled={false}
        />
        <h2>{new Date(this.state.date).toLocaleDateString('default', { month: 'long', year: 'numeric' })}</h2>
        <h3>New Uploads</h3>
        <MindfileTable
          mindfiles={this.state.monthly}
          sort={this.state.monthlySort}
          reverse={this.state.monthlyReverse}
          onChangeSort={(sort, reverse) => this.startMonthlyRequest(sort, reverse, this.state.date)}
          sortDisabled={this.state.loadingMonthly}
        />
        <Button
          disabled={!this.state.back || this.state.loadingMonthly}
          onClick={() => this.startMonthlyRequest(this.state.monthlySort, this.state.monthlyReverse, this.state.back)}
        >Back</Button>
        <Button
          disabled={!this.state.forward || this.state.loadingMonthly}
          onClick={() => this.startMonthlyRequest(this.state.monthlySort, this.state.monthlyReverse, this.state.forward)}
        >Forward</Button>
      </Box>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.auth,
  };
}

export default connect(mapStateToProps)(Users);

function MindfileTable(props) {
  // TODO: Add links to the Mindfile column once viewing of other mindfiles is implemented.
  const direction = props.reverse ? 'desc' : 'asc';
  return (
    <TableContainer style={{ maxHeight: '15em' }}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell key='name'>
              Mindfile
              <TableSortLabel
                disabled={props.sortDisabled}
                active={'name' === props.sort}
                direction={direction}
                // XOR means direction only reverses if the column is clicked after it is already the sort column:
                onClick={() => props.onChangeSort('name', 'name' === props.sort ^ props.reverse)}
              />
            </TableCell>
            <TableCell key='total'>
              Total
              <TableSortLabel
                disabled={props.sortDisabled}
                active={'bytes' === props.sort}
                direction={direction}
                onClick={() => props.onChangeSort('bytes', 'bytes' === props.sort ^ props.reverse)}
              />
            </TableCell>
            <TableCell key='created_at'>
              Account Created
              <TableSortLabel
                disabled={props.sortDisabled}
                active={'created_at' === props.sort}
                direction={direction}
                onClick={() => props.onChangeSort('created_at', 'created_at' === props.sort ^ props.reverse)}
              />
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody style={{backgroundColor: "#fff"}}>
          {props.mindfiles.map(row => (
            <TableRow key={row.id}>
              <TableCell key='name'>{row.name}</TableCell>
              <TableCell key='total'>{row.total}</TableCell>
              <TableCell key='created_at'>{row.created_at}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}